import { Button, Flex } from "@chakra-ui/react";
import { CustomModal } from "components/custom-modal";
import { DropdownField } from "components/dropdown-field";
import { InputField } from "components/input-field";
import {
  CampanhaWhatsAppCompletedDataProps,
  CampanhaWhatsAppListProps
} from "components/campanha-whatsapp-components/utils";
import { CampanhaWhatsAppEndpoints } from "../modal-campanha-whatsapp/utils";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { useState } from "react";
import { Toast } from "components/toast";
import api from "api/api";
import { WhatsAppSession } from "components/atendimentos-components/whatsapp-attendances/components/whats-app-chat/hooks/use-whats-app-session-controls/types";
import {
  maxLimit,
  minLimit
} from "components/mailing-components/mailing-modal-filter/consts";
import { onChangeMultiselect } from "components/dropdown/utils";

export type ModalSessoesWhatsAppParams = {
  campaignCompletedData: CampanhaWhatsAppCompletedDataProps;
  row: CampanhaWhatsAppListProps;
  onUpdate: () => void;
};

const getPhones = async () => {
  const { data } = await api.get<WhatsAppSession[]>(
    "/whatsapp-sessions?only_disparo=true"
  );
  return data.map(({ id, nome }) => ({ name: nome, value: id }));
};

const eventName = "openModalSessoesWhatsApp";

export const openModalSessoesWhatsApp =
  createModalTrigger<ModalSessoesWhatsAppParams>(eventName);

export function ModalSessoesWhatsApp() {
  const [isLoading, setIsLoading] = useState(false);
  const [wppSessionIds, setWppSessionIds] = useState<number[]>([]);
  const [qtdEstimadaEnvioDia, setQtdEstimadaEnvioDia] = useState("");

  const { isOpen, onClose, params } =
    useModalControls<ModalSessoesWhatsAppParams>(eventName, {
      onOpen(p) {
        setWppSessionIds(p?.campaignCompletedData?.wppSessionIds ?? []);
        setQtdEstimadaEnvioDia(
          String(p?.campaignCompletedData?.qtdEstimadaEnvioDia ?? "")
        );
      },
      onClose() {
        setWppSessionIds([]);
        setQtdEstimadaEnvioDia("");
      }
    });

  const handleSubmitUpdateSession = async () => {
    if (!params.row) return;
    try {
      await CampanhaWhatsAppEndpoints.updateCampanhaWhatsApp(params.row.id, {
        wppSessionIds,
        qtdEstimadaEnvioDia: Number(qtdEstimadaEnvioDia)
      });
      Toast({
        title: "Campanha WhatsApp atualizada com sucesso.",
        status: "success"
      });
      params.onUpdate?.();
    } catch {
      Toast({
        title:
          "Erro ao atualizar a campanha WhatsApp. Por favor, tente novamente."
      });
    }
  };

  const handleSubmit = async () => {
    if (wppSessionIds.length === 0) {
      Toast({ title: "Selecione pelo menos uma sessão WhatsApp." });
      return;
    }
    setIsLoading(true);
    try {
      await handleSubmitUpdateSession();
      onClose();
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  const modalFooter = (
    <>
      <Button onClick={handleSubmit} isLoading={isLoading}>
        Salvar
      </Button>
      <Button variant="outline" onClick={onClose} isDisabled={isLoading}>
        Cancelar
      </Button>
    </>
  );

  return (
    <CustomModal
      modalTitle="Sessões WhatsApp Participantes"
      isOpen={isOpen}
      onClose={onClose}
      modalFooter={modalFooter}
      size="md"
    >
      <Flex direction="column" gap="16px" py="8px">
        <DropdownField
          title="Selecione as Sessões WhatsApp:"
          value={wppSessionIds}
          asyncOptions={getPhones}
          onChange={(value) =>
            setWppSessionIds(onChangeMultiselect(value, wppSessionIds))
          }
          dropdownProps={{ multiSelect: true }}
        />
        <InputField
          title="Quantidade estimada de envios por dia:"
          value={qtdEstimadaEnvioDia}
          onChange={(e) =>
            setQtdEstimadaEnvioDia(
              `${minLimit(1, maxLimit(500, Number(e.target.value || 0)) || 1)}`
            )
          }
          inputProps={{ type: "number" }}
        />
      </Flex>
    </CustomModal>
  );
}
